import React from "react"
import { Switch } from "@chakra-ui/react"
import { Control, useController } from "react-hook-form"
import WALLET_PASS_BUILDER_COPY from "./walletPassBuilderCopy"
import { WalletPassBuilderFormValues } from "./walletPassBuilderTypes"
import PassBuilderFieldBlock from "./PassBuilderFieldBlock"

type Props = {
  control: Control<WalletPassBuilderFormValues>
}

const PassBuilderQrToggle = ({ control }: Props) => {
  const { field } = useController({ control: control as any, name: "qrCodeEnabled" })

  return (
    <PassBuilderFieldBlock
      title="QR Code"
      platform="both"
      appleStatus="recommended"
      googleStatus="recommended"
      description={WALLET_PASS_BUILDER_COPY.front.qrCode}
      rightElement={(
        <Switch
          size="lg"
          isChecked={Boolean(field.value)}
          onChange={(e) => field.onChange(e.target.checked)}
          colorScheme="blue"
          flexShrink={0}
        />
      )}
    />
  )
}

export default PassBuilderQrToggle
